// contextmenus.js
import { qs, qsAll } from '../utils/domHelpers.js';
import { ModalManager } from '../utils/modalManager.js';
import { stateManager } from '../utils/stateManager.js';
import { trapFocus, releaseFocus } from '../utils/focusManager.js';

export class ContextMenus {
  constructor(baseQueryEl) {
    this.baseQueryEl = baseQueryEl;
    this.initialModalHTML = new Map();
  }

  init() {
    // Toggle subfilters activating modals.
    this.baseQueryEl.addEventListener('click', (e) => {
      const toggle = e.target.closest('.toggle-subfilters');
      if (toggle) {
        e.preventDefault();
        const context = toggle.getAttribute('data-context');
        ModalManager.openModal(context);
        const modalEl = document.querySelector('.modal--' + context);
        if (modalEl && !this.initialModalHTML.has(context)) {
          this.initialModalHTML.set(context, modalEl.innerHTML);
        }
        if (modalEl) trapFocus(modalEl);
      }
    });

    // Close modals.
    this.baseQueryEl.addEventListener('click', (e) => {
      const closeEl = e.target.closest('.modal__close, .modal__bg');
      if (closeEl) {
        e.preventDefault();
        const modalEl = closeEl.closest('.modal__filters--wrapper');
        if (modalEl) {
          const contextClass = Array.from(modalEl.classList).find((cls) => cls.startsWith('modal--'));
          if (contextClass) {
            const context = contextClass.replace('modal--', '');
            const originalHTML = this.initialModalHTML.get(context);
            if (originalHTML) {
              modalEl.innerHTML = originalHTML;
              const reinitEvent = new CustomEvent('reinitContextMenus');
              document.dispatchEvent(reinitEvent);
            }
          }
        }
        ModalManager.closeActiveModal();
        releaseFocus();
      }
    });

    // Delegated close for inline-close-modal links.
    this.baseQueryEl.addEventListener('click', (e) => {
      const inlineClose = e.target.closest('.inline-close-modal');
      if (inlineClose) {
        e.preventDefault();
        const modalEl = inlineClose.closest('.modal');
        if (modalEl) {
          const contextClass = Array.from(modalEl.classList).find((cls) => cls.startsWith('modal--'));
          if (contextClass) {
            const context = contextClass.replace('modal--', '');
            const originalHTML = this.initialModalHTML.get(context);
            if (originalHTML) {
              modalEl.innerHTML = originalHTML;
            }
          }
        }
        stateManager.setState(null);
        document.body.classList.remove('search--previewed', 'cart--previewed', 'menu--open');
        ModalManager.closeActiveModal();
        releaseFocus();
      }
    });

    // Allow closing modals with Escape.
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        ModalManager.closeActiveModal();
        releaseFocus();
      }
    });

    // Handle overlay clicks.
    this.baseQueryEl.addEventListener('click', (e) => {
      const bg = e.target.closest('.modal-overlay, .cart-drawer__overlay');
      if (bg) {
        const modalEl = bg.closest('.modal');
        if (modalEl) {
          const contextClass = Array.from(modalEl.classList).find((cls) => cls.startsWith('modal--'));
          if (contextClass) {
            const context = contextClass.replace('modal--', '');
            const originalHTML = this.initialModalHTML.get(context);
            if (originalHTML) {
              modalEl.innerHTML = originalHTML;
            }
          }
        }
        stateManager.setState(null);
        document.body.classList.remove('search--previewed', 'cart--previewed', 'menu--open');
        ModalManager.closeActiveModal();
        releaseFocus();
      }
    });

    // Recheck scrollable overflow when modal is opened or on resize.
    const checkScrollableOverflow = () => {
      qsAll('.modal__scrollable').forEach((el) => {
        if (el.scrollHeight > el.clientHeight) {
          el.classList.add('has-overflow');
        } else {
          el.classList.remove('has-overflow');
        }
      });
    };

    window.addEventListener('resize', checkScrollableOverflow);

    // Override ModalManager openModal to inject overflow check.
    const originalOpenModal = ModalManager.openModal;
    ModalManager.openModal = function (...args) {
      originalOpenModal.apply(this, args);
      requestAnimationFrame(() => {
        checkScrollableOverflow();
        const modalEl = document.querySelector('.modal[aria-hidden="false"]');
        if (modalEl) {
          trapFocus(modalEl);
        }
      });
    };
  }
}
